let __shimInstalled = false;

function ensureHistoryShim() {
    if (typeof window === 'undefined' || __shimInstalled) return;

    const h = window.history;
    const origPush = h.pushState.bind(h) as History['pushState'];
    const origReplace = h.replaceState.bind(h) as History['replaceState'];

    const wrapState = (s: any) =>
        s != null && typeof s === 'object' ? s : { __wrapped: s ?? null };

    h.pushState = ((state: any, title: string, url?: string | URL | null) =>
        origPush(wrapState(state), title, url)) as History['pushState'];
    h.replaceState = ((state: any, title: string, url?: string | URL | null) =>
        origReplace(wrapState(state), title, url)) as History['replaceState'];

    __shimInstalled = true;
}

export type LoadPartDivParams = {
    manufacturer: string;
    partNumber: string;
    brand?: string; // 預設 'kemet'
    download?: number; // 預設 1
    format?: string; // 預設 'zip'
    anon?: number; // 預設 0
    region?: string; // 預設 ''
    language?: string; // 預設 'en-US'
    param1?: number; // 預設 1
    param2?: string; // 預設 ''
};

export function callLoadPartDiv({
    manufacturer,
    partNumber,
    brand = 'kemet',
    download = 1,
    format = 'zip',
    anon = 0,
    region = '',
    language = 'en-US',
    param1 = 1,
    param2 = '',
}: LoadPartDivParams): boolean {
    if (typeof window === 'undefined') return false;

    ensureHistoryShim();

    const fn = window.loadPartDiv;
    if (typeof fn !== 'function') return false;

    try {
        fn(
            manufacturer,
            partNumber,
            brand,
            download,
            format,
            anon,
            region,
            language,
            param1,
            param2
        );
        return true;
    } catch (e) {
        console.error('loadPartDiv failed', e);
        __shimInstalled = false;
        ensureHistoryShim();
        try {
            fn(
                manufacturer,
                partNumber,
                brand,
                download,
                format,
                anon,
                region,
                language,
                param1,
                param2
            );
            return true;
        } catch (e2) {
            console.error('loadPartDiv retry failed', e2);
            return false;
        }
    }
}
